import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { Form as BaseForm } from 'formik'
import { Link } from 'react-router-dom'

export const Container = styled.section``

export const Wrapper = styled.div`
  max-width: 470px;
  margin-left: auto;
  margin-right: auto;
`

export const Description = styled.p`
  margin-bottom: 38px;
  font-size: 1.125rem;
  text-align: center;
`

export const Form = styled(BaseForm)``

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Anchor = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  color: ${theme('color.lightGreen')};
`
